import { Upload } from './Upload';
import Axios from 'axios';
import { BASE_URL } from '../config/urls';
import Cloudinary from './Cloudinary';

const dataProvider = {
  getList: (resource: string, params: any) => {
    console.log('getList', resource, params);
    const { page, perPage } = params.pagination;
    const { field, order } = params.sort;
    const filter = params.filter;
    const query = {
      page: parseInt(page, 0),
      perPage: parseInt(perPage, 10),
      sortField: field,
      sortOrder: order === 'DESC' ? 'desc' : 'asc',
      filter: filter,
    };
    const url = `${BASE_URL}/${resource}/list`;
    return Axios.get(url, {
      params: query,
    }).then((res) => ({
      data: res.data.items,
      total: res.data.total,
    }));
  },

  getOne: (resource: string, params: any) =>
    Axios.get(`${BASE_URL}/${resource}/${params.id}`).then((res) => res),

  getMany: (resource: string, params: any) => {
    return Axios.get(`${BASE_URL}/${resource}/many`, {
      params: {
        id: params.ids,
      },
    }).then((res) => {
      return res;
    });
  },

  getManyReference: (resource: string, params: any) => {
    throw new Error('Not implemented');
  },

  update: async (resource: string, params: any) => {
    let imageUrl = undefined;
    if (params?.data?.image && params?.data?.image?.rawFile) {
      imageUrl = await Upload.uploadImage(params.data.image.rawFile);
    }
    return Axios.put(`${BASE_URL}/${resource}/${params.id}`, params.data).then(
      (res) => res
    );
  },
  updateMany: (resource: string, params: any) => {
    const query = {
      filter: JSON.stringify({ id: params.ids }),
    };
    return Axios.put(`${BASE_URL}/${resource}/${params.id}`, params.data, {
      params: query,
    }).then((res) => res);
  },

  create: async (resource: string, params: any) => {
    let imageUrl = undefined;
    if (params?.data?.image && params?.data?.image?.rawFile) {
      imageUrl = await Upload.uploadImage(params.data.image.rawFile);
    }
    return Axios.post(`${BASE_URL}/${resource}`, {
      ...params.data,
      image: imageUrl,
    }).then((res) => ({
      data: res.data,
    }));
  },

  delete: (resource: string, params: any) =>
    Axios.delete(`${BASE_URL}/${resource}/${params.id}`).then((res) => ({
      data: res.data,
    })),

  deleteMany: (resource: string, params: any) => {
    return Axios.delete(`${BASE_URL}/${resource}`, {
      data: { ids: params.ids },
    }).then((res) => ({
      data: [res.data],
    }));
  },
};

export default dataProvider;
